import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CrudPurchaseOrderService {
  _baseUrl = environment.baseUrl;
  options = {
    headers: new HttpHeaders({ "x-api-version": "2.0" }),
    withCredentials: true,
  };

  constructor(private readonly httpClient: HttpClient) {}

  savePurchaseOrder(model: any) {
    return this.httpClient.post<any>(
      `${this._baseUrl}FindiAssetPo/SavePurchaseOrder`,
      model,
      this.options
    );
  }

  updatePurchaseOrder(model: any) {
    return this.httpClient.post<any>(
      `${this._baseUrl}FindiAssetPo/UpdatePurchaseOrder`,
      model,
      this.options
    );
  }

 
   updatePurchaseOrderDetail(model: any) {
    return this.httpClient.post<any>(
      `${this._baseUrl}FindiAssetPo/UpdatePurchaseOrderDetail`,
      model,
      this.options
    );
  }

   getAllPurchaseOrders(model: any) {
    return this.httpClient.post<any>(
      `${this._baseUrl}FindiAssetPo/GetAllPurchaseOrders`,
      model,
      this.options
    );
  }

  deletePurchaseOrder(model: any) {
    return this.httpClient.post<any>(
      `${this._baseUrl}FindiAssetPo/DeletePurchaseOrder`,
      model,
      this.options
    );
  }

  getSampleForBulkPoUpload(): any {
    let options = {
      headers: new HttpHeaders({"x-api-version": "2.0"}),
      withCredentials: true,
      responseType: "blob" as "json", // Type assertion needed for blob responses
    };

    return this.httpClient.get(
      this._baseUrl + "FindiAssetPo/GetSampleForBulkPoUpload",
      options
    );
  }

  uploadFileToBulkCreatePos(model: any): Observable<any> {
      return this.httpClient.post<any>(
        this._baseUrl + "FindiAssetPo/UploadFileForBulkPo",
        model, this.options
      );
    }

}
